import { Button, Modal, Form, Input, Radio, Typography, message } from "antd";

import React, { useState, useRef } from "react";
import useAdminHttp from "../hooks/useAdminHttp";
import { ERROR_MESSAGES } from "../../constants/messages/locale";

export default function UserActions({ osyncIds, fetchUserData, formFields }) {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const newUserDetailsRef = useRef({});

  const { Title } = Typography;
  const { fetchData } = useAdminHttp();
  const handleAddUser = () => {
    const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    const { name, email, remoteUserId } = newUserDetailsRef.current;
    console.log(osyncIds, name, email, remoteUserId, emailRegex.test(email));
    if (osyncIds["Osync ID"] && email && emailRegex.test(email) && remoteUserId) {
      const stringifyUser = JSON.stringify(newUserDetailsRef.current);

      try {
        fetchData("customer/users/add?osyncId=" + osyncIds["Osync ID"], "post", stringifyUser)
          .then((res) => {
            if (res?.status === 200) {
              const data = res?.data;
              newUserDetailsRef.current = {};
              if (data) {
                if (data?.status) {
                  fetchUserData(osyncIds["Osync ID"]);
                  message.success(data?.message);
                } else {
                  message.error(data?.message);
                }
              }
            }
          })
          .catch((error) => {
            message.error(error.message);
          })
          .finally(() => {
            setIsModalOpen(false);
            form.resetFields();
          });
      } catch (error) {
        message.error(error?.message);
      }
    } else {
      message.error(ERROR_MESSAGES.VALIDATION.ALL_FIELDS_REQUIRED);
    }
  };

  const handleModal = () => {
    console.log("User form fields in handle modal", formFields);
    if (formFields) {
      setIsModalOpen(true);
    } else {
      message.error("Error parsing User Schema");
    }
  };

  const handleChange = (event, fields) => {
    newUserDetailsRef.current[fields] = event.target.value;
  };

  const handleOsyncIdChange = (event, fields, osyncIds) => {
    newUserDetailsRef.current[fields] = event.target.value;
    newUserDetailsRef.current["osyncId"] = osyncIds["Osync ID"];
  };

  return (
    <>
      <Button className="actionsButton" onClick={() => handleModal()}>
        Add User
      </Button>
      <Modal
        open={isModalOpen}
        onOk={handleAddUser}
        onCancel={() => {
          setIsModalOpen(false);
          form.resetFields();
        }}
        okText="Add"
        okButtonProps={{ form: "addUserForm", htmlType: "submit" }}
      >
        <Form form={form} layout="vertical" id="addUserForm">
          <Title style={{ padding: "10px 0px" }} level={3}>
            User Details
          </Title>
          {formFields ? (
            Object.keys(formFields).map((fields) => {
              if (fields !== "shardId" && fields !== "osyncUserId" && fields !== "osyncId") {
                if (fields === "remoteUserId" || fields === "email") {
                  return (
                    <Form.Item key={fields} label={fields?.toUpperCase()} name={fields} required={true}>
                      <Input onChange={(e) => handleChange(e, fields)} />
                    </Form.Item>
                  );
                } else {
                  return (
                    <Form.Item key={fields} label={fields?.toUpperCase()} name={fields}>
                      <Input onChange={(e) => handleChange(e, fields)} />
                    </Form.Item>
                  );
                }
              }
              return null;
            })
          ) : (
            <></>
          )}
        </Form>
      </Modal>
    </>
  );
}
